<script>
    import { RichTextEditor } from "../../../Components/Common/index.svelte";

    export let topHeaderConfig = {};

    let previewRef;

    $: if (previewRef) {
        if (!topHeaderConfig?.content) previewRef.setContent("");
        else previewRef.setContent(topHeaderConfig.content);
    }
</script>

<RichTextEditor
    bind:this={previewRef}
    content={topHeaderConfig.content}
    config={{
        isDisabled: true,
        style: {
            border: "none",
        },
    }}
/>
